export const timeColumns = [
  {
    field: "id",
    headerName: "ID",
    align: "center",
    headerAlign: "center",
    width: 100,
    hide: true,
  },

  {
    field: "date",
    headerName: "DATE",
    align: "center",
    headerAlign: "center",
    width: 100,
  },

  {
    field: "base",
    headerName: "BASE",
    align: "center",
    headerAlign: "center",
    width: 100,
    editable: true,
  },
  {
    field: "premium",
    headerName: "PREMIUM",
    align: "center",
    headerAlign: "center",
    width: 100,
    editable: true,
  },
  {
    field: "hoursLogged",
    headerName: "HOURSE LOGGED",
    type: "number",
    align: "center",
    headerAlign: "center",
    width: 140,
  },
  {
    field: "startDateTime",
    headerName: "START DATE TIME",
    align: "center",
    headerAlign: "center",
    sortable: false,
    width: 150,
  },
  {
    field: "endDateTime",
    headerName: "END DATE TIME",
    sortable: true,
    align: "center",
    headerAlign: "center",
    width: 150,
  },
];

export const timeRows = [
  {
    id: 1,
    date: "08-07-2022",
    base: "demo",
    premium: "demo",
    hoursLogged: 35,
    startDateTime: "demo",
    endDateTime: "assigned",
  },
  {
    id: 2,
    date: "08-07-2022",
    base: "demo",
    premium: "demo",
    hoursLogged: 42,
    startDateTime: "demo",
    endDateTime: "assigned",
  },
  {
    id: 3,
    date: "08-07-2022",
    base: "demo",
    premium: "demo",
    hoursLogged: 45,
    startDateTime: "demo",
    endDateTime: "assigned",
  },
  {
    id: 4,
    date: "08-07-2022",
    base: "demo",
    premium: "demo",
    hoursLogged: 16,
    startDateTime: "demo",
    endDateTime: "assigned",
  },
  {
    id: 4,
    date: "08-07-2022",
    base: "demo",
    premium: "demo",
    hoursLogged: 16,
    startDateTime: "demo",
    endDateTime: "assigned",
  },
  {
    id: 4,
    date: "08-07-2022",
    base: "demo",
    premium: "demo",
    hoursLogged: 16,
    startDateTime: "demo",
    endDateTime: "assigned",
  },
  {
    id: 4,
    date: "08-07-2022",
    base: "demo",
    premium: "demo",
    hoursLogged: 16,
    startDateTime: "demo",
    endDateTime: "assigned",
  },
];

export const expenseColumns = [
  {
    field: "id",
    headerName: "ID",
    align: "center",
    headerAlign: "center",
    width: 150,
    hide: true,
  },

  {
    field: "date",
    headerName: "Date",
    align: "center",
    headerAlign: "center",
    width: 100,
  },

  {
    field: "itemDesc",
    headerName: "Item Description",
    align: "center",
    headerAlign: "center",
    width: 150,
    editable: true,
  },
  {
    field: "category",
    headerName: "Category",
    align: "center",
    headerAlign: "center",
    width: 150,
    editable: true,
  },
  {
    field: "chargeType",
    headerName: "Charge Type",
    type: "number",
    align: "center",
    headerAlign: "center",
    width: 180,
  },
  {
    field: "expenseType",
    headerName: "Expense Type",
    align: "center",
    headerAlign: "center",
    sortable: false,
    width: 180,
  },
  {
    field: "amount",
    headerName: "Amount",
    sortable: false,
    align: "center",
    headerAlign: "center",
    width: 180,
  },
  {
    field: "receiptImage",
    headerName: "Receipt Image",
    sortable: false,
    align: "center",
    headerAlign: "center",
    width: 150,
  },
  {
    field: "action",
    headerName: "Action",
    sortable: false,
    align: "center",
    headerAlign: "center",
    width: 150,
  },
];

export const expenseRows = [
  {
    id: 1,
    date: "08-07-2022",
    itemDesc: "demo",
    category: "demo",
    chargeType: 35,
    expenseType: "demo",
    amount: "assigned",
    receiptImage: "",
    action: "",
  },
  {
    id: 2,
    date: "08-07-2022",
    itemDesc: "demo",
    category: "demo",
    chargeType: 42,
    expenseType: "demo",
    amount: "assigned",
    receiptImage: "",
    action: "",
  },
  {
    id: 3,
    date: "08-07-2022",
    itemDesc: "demo",
    category: "demo",
    chargeType: 45,
    expenseType: "demo",
    amount: "assigned",
    receiptImage: "",
    action: "",
  },
];
